import { render, staticRenderFns } from "./SquareLocationSelector.vue?vue&type=template&id=2feb6df8&scoped=true"
import script from "./SquareLocationSelector.vue?vue&type=script&lang=js"
export * from "./SquareLocationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb6df8",
  null
  
)

export default component.exports